import type { IconTheme } from './light'
import { commonDark } from '../../_styles/common'
import { self } from './light'

const iconDark: IconTheme = {
  name: 'Icon',
  common: commonDark,
  self
}

export default iconDark
